module.exports = __webpack_public_path__ + "assets/img/648ebfd20a6c0e2a0ecc5f7ff9604647.webp";